import React from "react";
import Navbar from "./Navbar";
import ProjectCard from "./ProjectCard";
import "./ProjectScreen.css";
import Netflix from "./images/netflix.png";
import Airbnb from "./images/airbnb.png";
import CovidTracker from "./images/covid-tracker.png";
import ColorGenerator from "./images/color-generator.png";
import Tesla from "./images/tesla.png";
import Signal from "./images/signal.png";
import { motion } from "framer-motion";

function ProjectScreen() {
	const pageVariants = {
		initial: {
			opacity: 0,
			x: "-100vw",
		},
		in: {
			opacity: 1,
			x: 0,
		},
		out: {
			opacity: 0,
			x: "100vw",
		},
	};
	const pageTransition = {
		type: "spring",
		stiffness: 65,
		duration: 0.2,
	};
	return (
		<div className="projectScreen">
			<Navbar />
			<motion.div
				className="project__list"
				initial="out"
				animate="in"
				exit="out"
				variants={pageVariants}
				transition={pageTransition}
			>
				<div className="project__item">
					<ProjectCard
						projectImage={CovidTracker}
						title="Covid-19 Tracker"
						description="A web app that displays the covid-19 daily, total cases, recoveries and deceased according to the country a user selects."
						projectLink="https://covid-19-app-17f14.web.app/"
					/>
					<ProjectCard
						projectImage={ColorGenerator}
						title="Color Generator"
						description="Generates shades, hex color code of the color a user enters which can be copied to the clipboard too."
						projectLink="https://21shades.netlify.app/"
					/>
					<ProjectCard
						projectImage={Netflix}
						title="Netflix-clone"
						description="A web app which has similar UI to Netflix, also plays the youtube videos of selected titles."
						projectLink="http://netflix-clone-cf124.web.app"
					/>
					<ProjectCard
						projectImage={Airbnb}
						title="Airbnb-clone"
						description="Airbnb clone web app which also contains the date picker, number of guests to select and a pleasing UI."
						projectLink="https://airbnb-clone-2021.netlify.app/"
					/>
					<ProjectCard
						projectImage={Tesla}
						title="Tesla homepage"
						description="Tesla landing page with ReactJs that contains all the Tesla products."
						projectLink="https://tesla-clone-2021.netlify.app/"
					/>

					<ProjectCard
						projectImage={Signal}
						title="Chat App"
						description="React Native chat app which allows the user to put up a group chat logging forth into it."
						projectLink="https://signal-clone-ad9b7.web.app/"
					/>
				</div>
			</motion.div>
		</div>
	);
}

export default ProjectScreen;
